import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Image from 'components/Common/Image'
import TextLink from 'LuxKit/TextLink'
import useLoyaltyCampaignOffers from 'loyalty/hooks/useLoyaltyCampaignOffers'
import Group from 'components/utils/Group'

const Section = styled(Pane)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

const OfferGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(24)};
  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQueryUp.desktop} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const OfferCard = styled(Pane)`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};
  height: 100%;
  border: none;
`

const OfferImageContainer = styled.div`
  width: 100%;
  height: ${rem(200)};
  overflow: hidden;
`

function LoyaltyAccountCurrentOffersSection() {
  const intl = useIntl()
  const offers = useLoyaltyCampaignOffers()

  if (offers.length === 0) return null

  const sectionHeading = intl.formatMessage({
    id: 'kGYr7zmc0s',
    defaultMessage: 'Current offers to earn & save more',
    description: 'Section heading for loyalty campaign offers on account page',
  })

  const browseOffersLabel = intl.formatMessage({
    id: 'g3I24iyRvN',
    defaultMessage: 'Browse offers',
    description: 'Link text to browse loyalty campaign offers',
  })

  return (
    <Section background="neutral-eight">
      <LayoutContainer variant="large">
        <VerticalSpacer gap={24}>
          <Heading variant="heading3">{sectionHeading}</Heading>
          <OfferGrid>
            {offers.map(offer => {
              const title = intl.formatMessage(offer.title)
              return <OfferCard
                key={title}
                background="neutral-eight"
                borderRadius="L"
              >
                <OfferImageContainer>
                  <Image id={offer.imageId} height={200} fit="center" />
                </OfferImageContainer>
                <Group direction="vertical" gap={16}>
                  <Heading variant="heading4">{title}</Heading>
                  <BodyText variant="medium">{intl.formatMessage(offer.description)}</BodyText>
                  <TextLink size="medium" weight="regular" to={offer.link}>
                    {browseOffersLabel}
                  </TextLink>
                </Group>
              </OfferCard>
            })}
          </OfferGrid>
        </VerticalSpacer>
      </LayoutContainer>
    </Section>
  )
}

export default LoyaltyAccountCurrentOffersSection
